import { createThunkEffect } from '../../../utilities/ActionUtility';
import { getCurrentUser, putOwnUser, saveUser } from './UserEffect';

export const REQUEST_SAVE_USER = 'REQUEST_SAVE_USER';
export const REQUEST_SAVE_USER_FINISHED = 'REQUEST_SAVE_USER_FINISHED';
export const RESET_SAVE_USER = 'RESET_SAVE_USER';
export const REQUEST_PUT_OWN_USER = 'UserActions.REQUEST_PUT_OWN_USER';
export const REQUEST_PUT_OWN_USER_FINISHED = 'UserActions.REQUEST_PUT_OWN_USER_FINISHED';
export const REQUEST_CURRENT_USER = 'UserActions.REQUEST_CURRENT_USER';
export const REQUEST_CURRENT_USER_FINISHED = 'UserActions.REQUEST_CURRENT_USER_FINISHED';
export const RESET_CURRENT_USER = 'UserActions.RESET_CURRENT_USER';

export function updateUser(user, email, mobile) {
  return async (dispatch) => {
    await createThunkEffect(dispatch, REQUEST_SAVE_USER, saveUser, {
      ...user,
      email: email || null,
      mobile: mobile || null
    });
  };
}

export function resetSaveUser() {
  return {
    type: RESET_SAVE_USER
  };
}

export function updateOwnUser(idToken) {
  return async (dispatch) => {
    return await createThunkEffect(dispatch, REQUEST_PUT_OWN_USER, putOwnUser, idToken);
  };
}

export function requestCurrentUser() {
  return async (dispatch) => {
    return await createThunkEffect(dispatch, REQUEST_CURRENT_USER, getCurrentUser);
  };
}

export function resetCurrentUser() {
  return {
    type: RESET_CURRENT_USER
  };
}